/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Auto_TitleInputs */

const en_mk_build_auto_title = /** @type {(inputs: Mk_Build_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic`)
};

const id_mk_build_auto_title = /** @type {(inputs: Mk_Build_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatis`)
};

/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Mk_Build_Auto_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_auto_title = /** @type {((inputs?: Mk_Build_Auto_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Auto_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_auto_title(inputs)
	return en_mk_build_auto_title(inputs)
});